export const worldPtBR = {
  'world.seo.title': 'O Mundo',
  'world.seo.description':
    'Explore os mapas interativos de Grymwyrd — seus reinos, ruínas e cenas de lenda em cartografia 2D e um globo 3D rotativo.',
  'world.heading': 'O Mundo',
  'world.intro':
    'Navegue pelo crepúsculo eterno. O atlas foi construído para visão aninhada — amplie do mundo inteiro até um calabouço único. Apenas o nível superior é interativo por enquanto; níveis mais profundos se abrirão conforme os reinos forem mapeados.',

  'world.viewMode.label': 'Modo de visualização do mapa',
  'world.viewMode.map2d': 'Mapa 2D',
  'world.viewMode.globe3d': 'Globo 3D',

  'world.gazetteer.navLabel': 'Locais e cenas',
  'world.gazetteer.heading': 'Guia Geográfico',
  'world.gazetteer.sampleNotice':
    'Mostrando locais de exemplo — o verdadeiro levantamento do cartógrafo ainda não foi registrado.',
  'world.gazetteer.error': 'O arquivo do atlas não pôde ser alcançado.',

  'world.loading.atlas': 'Desenrolando o atlas…',
  'world.loading.globe': 'Girando o mundo…',

  'world.layersActive': '{active} de {total} camadas ativas.',
  'world.globeHint':
    'Arraste para girar (a rotação automática pausa enquanto você explora, retomando após um minuto inativo); role para ampliar. Passe o mouse por um hexágono para revelar sua campanha, clique para entrar.',
  'world.webglUnavailable':
    'O globo 3D precisa de WebGL, que não está disponível aqui — mostrando o atlas 2D em seu lugar.',

  'world.campaign.capitalRegion': 'Região da Capital',
  'world.campaign.territory': 'Território de Campanha',
  'world.campaign.enter': 'Entrar na Campanha',
  'world.campaign.stay': 'Permanecer em Órbita',

  'world.layers.heading': 'Camadas do Mapa',
  'world.layers.gmBadge': 'MJ',
  'world.layers.gmRequired': 'Requer função de Mestre de Jogo.',

  'world.marker.sampleBadge': 'Dados de exemplo',
  'world.marker.viewInEncyclopedia': 'Ver na Enciclopédia',
  'world.marker.placeholderNote':
    'Este é um local placeholder — uma vez que sua lenda for escrita, ele será vinculado à Enciclopédia.',

  'world.map2d.ariaLabel': 'Mapa interativo do mundo',
  'world.map2d.noOverworld': 'Cartografia do mundo não foi inscrita ainda — mostrando o vazio',

  'world.globe.hint.enter': 'Entrar ▸',
  'world.globe.hint.open': 'Abrir ▸',
  'world.globe.hint.claim': 'Reivindicar ▸',
  'world.globe.uncharted': 'Alcances Inexplorados',
  'world.globe.unchartedBlurb':
    'Nenhuma campanha reclamou este hexágono do crepúsculo eterno. Levante o primeiro estandarte.',
  'world.globe.capitalLabel': 'Grymwyrd',
} as const
